type CompanyHostname = 'panel.2kk.team' | 'panel.stormlead.team' | 'panel.trafficlegion.team' | 'default';

const companyConfig: Record<CompanyHostname, { title: string; iconSuffix?: string }> = {
  'panel.2kk.team': {
    title: '2KK TEAM PANEL',
    iconSuffix: '2kk',
  },
  'panel.stormlead.team': {
    title: 'STORMLEAD TEAM PANEL',
  },
  'panel.trafficlegion.team': {
    title: 'TRAFFIC LEGION TEAM PANEL',
  },
  default: {
    title: 'ADWAY TEAM PANEL',
  },
};

const assertHostname = (hostname: string): hostname is CompanyHostname => {
  return hostname in companyConfig;
};

const validateHostname = (hostname: string): CompanyHostname => {
  return assertHostname(hostname) ? hostname : 'default';
};

const changeTitle = (hostname: CompanyHostname) => {
  const title = companyConfig[hostname].title;
  document.title = title;
};

const iconConfig = [
  {
    label: 'main',
    selector: 'link[rel="icon"]',
    getFilename: (suffix) => `favicon${suffix ? `-${suffix}` : ''}.ico`,
  },
  {
    label: '16x16',
    selector: 'link[rel="icon"][sizes="16x16"]',
    getFilename: (suffix) => `favicon-16x16${suffix ? `-${suffix}` : ''}.png`,
  },
  {
    label: '32x32',
    selector: 'link[rel="icon"][sizes="32x32"]',
    getFilename: (suffix) => `favicon-32x32${suffix ? `-${suffix}` : ''}.png`,
  },
  {
    label: 'apple',
    selector: 'link[rel="apple-touch-icon"]',
    getFilename: (suffix) => `apple-touch-icon${suffix ? `-${suffix}` : ''}.png`,
  },
] satisfies { label: string; selector: string; getFilename: (suffix: string) => string }[];

const changeIcon = (hostname: CompanyHostname) => {
  const suffix = companyConfig[hostname].iconSuffix ?? null;

  if (!suffix) return;

  iconConfig.forEach(({ label, selector, getFilename }) => {
    const icon = document.querySelector<HTMLLinkElement>(selector);

    if (!icon) return;

    let iconFileName = getFilename(suffix);

    if (suffix === '2kk' && label === 'apple') {
      iconFileName = iconConfig[2].getFilename(suffix);
    }

    icon.href = iconFileName;
  });
};

export const init = () => {
  const hostname = validateHostname(window.location.hostname);

  changeTitle(hostname);
  changeIcon(hostname);
};
